import styled from "styled-components";
import { MdLocationPin, MdAlternateEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa";

export const ContactMeContainer = styled.div`
  background: ${({ light }) => (light ? "white" : "#0a0806")};
  margin-bottom: 200px;
  padding: 4rem 0 2rem 0;
  border-top: 2px solid 828282;
  align-items: center;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media screen and (max-width: 820px) {
    margin-bottom: 350px;
  }
`;

export const ContactMeRow = styled.div`
  display: flex;
  background: ${({ light }) => (light ? "#272727" : "#0a0806")};
  border-radius: 20px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;

  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ContactMeData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 20px;
`;

export const ContactMeDataPersonal = styled.p`
  font-size: 20px;
  color: #828282;
`;

export const ContactMeLinksItems = styled.div`
  display: flex;
  margin: 16px;
  text-align: center;
  width: 160px;
  box-sizing: border-box;
  color: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 820px) {
    margin: 0;
    padding: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
`;

export const ContactMeLink = styled.p`
  color: ${({ light }) => (light ? "#ef9a9a" : "#a2cadf")};
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 17px;

  &:hover {
    color: ${({ light }) => (light ? "#5dc1b9" : " #0467fb")};
    transition: 0.3s ease-out;
  }

  @media screen and (max-width: 820px) {
    margin-bottom: 0;
    font-size: 15px;
  }
`;

export const ContactMeLinkTitle = styled.div`
  margin-bottom: 16px;
  color: ${({ light }) => (light ? "#e57373" : "#00aae4")};
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 820px) {
    margin: 0;
    padding: 20px;
    width: 100%;
    justify-content: center;
    font-size: 1.25rem;
  }
`;

export const ContactMeLocationIcon = styled(MdLocationPin)`
  margin-left: 0.5rem;
`;

export const ContactMeEmailIcon = styled(MdAlternateEmail)`
  margin-left: 0.5rem;
`;

export const ContactMePhoneIcon = styled(FaPhone)`
  margin-left: 0.5rem;
`;

export const ContactMeSubscription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  margin-bottom: 24px;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  padding: 40px;

  @media screen and (max-width: 960px) {
    justify-content: center;
    align-items: center;
    width: 60%;
    @media screen and (max-width: 820px) {
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }
`;

export const ContactMeSubHeading = styled.h1`
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  padding-bottom: 60px;
  color: ${({ light }) => (light ? " #c62828" : " #52b2bf")};
  font-size: 80px;
  padding-top: 60px;

  @media screen and (max-width: 820px) {
    font-size: 50px;
  }
`;

export const ContactMeSubText = styled.div`
  margin-bottom: 24px;
  font-size: 20px;
  color: #828282;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;

  @media screen and (max-width: 1085px) {
    width: 95%;
  }
`;

export const FormInput = styled.input`
  padding: 10px 20px;
  display: block;
  width: 100%;
  border-radius: 5px;
  margin-bottom: 12px;
  outline: none;
  font-size: 16px;
  border: none;
  border: 2px solid ${({ light }) => (light ? " #e57373" : " #497e76")};
  background-color: transparent;
  color: #f7f8fa;

  &::placeholder {
    color: #f7f8fa;
    padding: 5px 10px;
  }
`;

export const FormInputMessage = styled.textarea`
  display: block;
  height: 120px;
  padding: 0px 20px;
  width: 100%;
  line-height: 46px;
  border-radius: 5px;
  margin-bottom: 12px;
  outline: none;
  font-size: 16px;
  border: 2px solid ${({ light }) => (light ? " #e57373" : " #497e76")};
  background-color: transparent;
  outline: none;
  color: #f7f8fa;

  &::placeholder {
    color: #f7f8fa;
    padding: 5px 10px;
  }
`;

export const Button = styled.button`
  background-color: transparent;
  color: #f7f8fa;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  border: 2px solid ${({ light }) => (light ? " #e57373" : " #497e76")};
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background-color: ${({ light }) => (light ? " #e57373" : " #009c8c")};
    color: black;
    border: 2px solid ${({ light }) => (light ? " #c81d11" : " #37615b")};
    font-weight: bold;
  }

  @media screen and (max-width: 820px) {
    width: 80%;
  }
`;
